// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bill-container {
  background-color: #fff;
  border: 4px solid #1f53cd;
  padding: 20px;
  width: 800px;
  /* Adjust width as needed */
  font-family: sans-serif;
  margin-top: 10px;
}

.bill-header {
  display: grid;
  justify-content: center;
  margin-bottom: 20px;
  text-align: center;
}

.municipal-council,
.form,
.bill-title,
.financial-year {
  font-size: 18px;
  font-weight: bold;
}

.bill-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.estate-details,
.bill-details,
.assessment-details,
.owner-details,
.tax-details,
.notes {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  color: #1f53cd;
}

.tax-details-title,
.assessment-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.tax-table {
  width: 100%;
  border-collapse: collapse;
}

.tax-table th,
.tax-table td {
  padding: 5px;
  border: 1px solid #ddd;
  text-align: left;
}

.notes {
  font-size: 12px;
}

.note {
  margin-bottom: 5px;
}

.innerheader {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: bolder;
}



.tableContainer {
  table {

    thead,
    tr,
    th {
      font-size: 12px;
    }

    tbody,
    tr,
    td {
      font-size: 12px;
    }
  }
}


.tableDesign {

  background: linear-gradient(to Right, #3b409e, #0067ab, #0f79ba, #0098d5);
  border: 1px solid #3b409e;

  table {
    width: 100%;
    border-collapse: collapse;
    /* border: 1px solid #AFD1F6 !important; */

    thead {
      tr {
        color: 'white';
        height: '3.5rem';
        /* border: 1px solid #AFD1F6 !important; */

        th {
          border: 1px solid #AFD1F6 !important;
        }
      }
    }

    tbody {
      tr {
        color: 'white';
        height: '3.5rem';
        border: 1px solid #AFD1F6 !important;

        td {
          border: 1px solid #AFD1F6 !important;
        }
      }
    }


  }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/AdministrativeApproval/bill.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;;;;;;EAME,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;;;AAIA;EACE;;IAEE;;;MAGE,eAAe;IACjB;;IAEA;;;MAGE,eAAe;IACjB;EACF;AACF;;;AAGA;;EAEE,yEAAyE;EACzE,yBAAyB;;EAEzB;IACE,WAAW;IACX,yBAAyB;IACzB,0CAA0C;;IAE1C;MACE;QACE,cAAc;QACd,gBAAgB;QAChB,0CAA0C;;QAE1C;UACE,oCAAoC;QACtC;MACF;IACF;;IAEA;MACE;QACE,cAAc;QACd,gBAAgB;QAChB,oCAAoC;;QAEpC;UACE,oCAAoC;QACtC;MACF;IACF;;;EAGF;AACF","sourcesContent":[".bill-container {\n  background-color: #fff;\n  border: 4px solid #1f53cd;\n  padding: 20px;\n  width: 800px;\n  /* Adjust width as needed */\n  font-family: sans-serif;\n  margin-top: 10px;\n}\n\n.bill-header {\n  display: grid;\n  justify-content: center;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.municipal-council,\n.form,\n.bill-title,\n.financial-year {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.bill-body {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.estate-details,\n.bill-details,\n.assessment-details,\n.owner-details,\n.tax-details,\n.notes {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 20px;\n  color: #1f53cd;\n}\n\n.tax-details-title,\n.assessment-title {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.tax-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.tax-table th,\n.tax-table td {\n  padding: 5px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.notes {\n  font-size: 12px;\n}\n\n.note {\n  margin-bottom: 5px;\n}\n\n.innerheader {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  font-weight: bolder;\n}\n\n\n\n.tableContainer {\n  table {\n\n    thead,\n    tr,\n    th {\n      font-size: 12px;\n    }\n\n    tbody,\n    tr,\n    td {\n      font-size: 12px;\n    }\n  }\n}\n\n\n.tableDesign {\n\n  background: linear-gradient(to Right, #3b409e, #0067ab, #0f79ba, #0098d5);\n  border: 1px solid #3b409e;\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    /* border: 1px solid #AFD1F6 !important; */\n\n    thead {\n      tr {\n        color: 'white';\n        height: '3.5rem';\n        /* border: 1px solid #AFD1F6 !important; */\n\n        th {\n          border: 1px solid #AFD1F6 !important;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        color: 'white';\n        height: '3.5rem';\n        border: 1px solid #AFD1F6 !important;\n\n        td {\n          border: 1px solid #AFD1F6 !important;\n        }\n      }\n    }\n\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
